var map = {
	"./image_1.jpg": 14,
	"./image_10.jpg": 15,
	"./image_2.jpg": 16,
	"./image_3.jpg": 17,
	"./image_4.jpg": 18,
	"./image_5.jpg": 19,
	"./image_6.jpg": 20,
	"./image_7.jpg": 21,
	"./image_8.jpg": 22,
	"./image_9.jpg": 23,
	"./logo.svg": 2,
	"./wave.svg": 24,
	"./zigzag.svg": 25
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13;